
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from '../system/index.js';
import type { NavInternalLink, NavExternalLink } from './index.js';
import type { Products, Roles } from '../taxonomies/index.js';

/**
 * 🔗 Nav // Sub Item
 *
 * Id: d65b2171-47b9-4c2e-84cd-bac477fc1ee1
 * Codename: menu_sub_item
 */
export type NavSubItem = CoreContentType<
    NavSubItemElementCodenames,
    {
        /**
         * Link
         *
         * Type: modular_content
         * Required: true
         * Codename: link
         * Id: 54a91dab-78bc-4cc8-a8fb-0f482ec626c1
         */
        readonly link: Elements.LinkedItemsElement<NavInternalLink | NavExternalLink>;
        /**
         * Products
         *
         * Type: taxonomy
         * Required: false
         * Codename: products
         * Id: 7a4c1dec-1761-4c77-8bda-966c5f4b5654
         * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
         */
        readonly products: Elements.TaxonomyElement<Products, 'products'>;
        /**
         * Roles
         *
         * Type: taxonomy
         * Required: false
         * Codename: roles
         * Id: 3e4c983c-67b4-4cd7-8c13-58b6c5c41ba3
         * Guidelines: • Restrict the visibility of this content to users with selected roles. • If no roles are selected, the content will be visible to all users.
         */
        readonly roles: Elements.TaxonomyElement<Roles, 'roles'>;
    },
    'menu_sub_item'
>;

/**
 * Type representing all available element codenames for 🔗 Nav // Sub Item
 */
export type NavSubItemElementCodenames = 'link' | 'products' | 'roles';

/**
 * Type guard for 🔗 Nav // Sub Item
 *
 * Id: d65b2171-47b9-4c2e-84cd-bac477fc1ee1
 * Codename: menu_sub_item
 */
export function isNavSubItem(item: CoreContentType | undefined | null): item is NavSubItem {
    return item?.system?.type === 'menu_sub_item';
}
